<template>
  <v-card width="100%" class="ma-0 pa-2 mt-2" elevation="0" outlined>
    <v-card-title class="blue--text pa-0 ma-0 ml-1 mb-2">Spring</v-card-title>
    <v-row dense>
      <v-col cols="12" md="4" sm="4">
        <r-range :model.sync="value.shotImpulse" label="Shot impulse"/>
      </v-col>
      <v-col cols="12" md="4" sm="4">
        <r-range :model.sync="value.shotDeviation" label="Shot Deviation"/>
      </v-col>
      <v-col cols="12" md="4" sm="4">
        <r-range :model.sync="value.touchImpulse" label="Touch impulse"/>
      </v-col>
      <v-col cols="12" md="12" sm="12">
        <v-text-field v-model.trim="value.excludeImpulseString" label="Exclude Impulse" :rules="[validator.points]" hint="Example: 1;3;5"/>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import VueTypes from "vue-types";
import {PlinkoSpringConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoSpringConfig";

import RRange from "@/modules/redactor/views/utils/r-range.vue";

export default {
  name: "r-plinko-spring-config",
  components: {RRange},
  props: {
    model: VueTypes.instanceOf(PlinkoSpringConfig)
  },
  data: () => ({
    validator: {
      points: value => value.length === 0 || !value.split(";").map(Number).some(v => !Number.isInteger(v) || v <= 0)
    }
  }),
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new PlinkoSpringConfig();
        this.$emit("update:model", value);
        return value;
      }
    }
  }
}

</script>